import { useState, useMemo } from 'react';
import { useRouter } from 'next/router';

const usePopupError = () => {
  const router = useRouter();
  const { transactionId } = router.query;

  const key = `${transactionId}.error`;

  const errorCode = useMemo(() => {
    let value = typeof window === 'object' && window.localStorage.getItem(key);
    return value ? JSON.parse(value) : null;
  }, [key]);

  const [error, _setError] = useState(errorCode);

  const setError = value => {
    _setError(value);
    typeof window === 'object' &&
      window.localStorage.setItem(key, JSON.stringify(value));
  };

  const clearError = () => {
    setError(null);
    typeof window === 'object' && window.localStorage.removeItem(key);
  };

  return { error, setError, clearError };
};

export default usePopupError;
